import Component from "./lazy";


export default Component;
